import React from 'react';
import { getCurrentVersion } from '~/utils/helpers';
import SplashLayout from './layout';

export default function Splash(): JSX.Element {
  const version = getCurrentVersion();
  return <SplashLayout version={version} />;
}
